<template>
  <div v-bind:style="{ backgroundColor: color}" >
      <div style="padding-top:2px; padding-bottom: 200px">
        <span
          style="display: table; width: 100%; color: #3498db; text-align: center"
          class='not-found'>
          <div class="row justify-content-md-center justify-content-center">
            <div class="col-md-3 col-4 text-center">
              <img :src="staticImg+'notfound.png'" alt="404 Not Found"/>
            </div>
          </div>
          <h2 class="headerTwo">We can't seem to find the page you are looking for</h2>
        </span>
        <button class="btn btn-primary btn-lg btn-block mb15 pointer text-uppercase center" @click="home">Let's take you home</button>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      staticImg: process.env.STATIC_IMG,
      color: '#f7f7f7'
    }
  },
  methods: {
    home () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
    .not-found {
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 10px;
      margin-top: 50px;
    }
    .headerOne {
      font-size: 6em;
      margin-left: auto;
      margin-right: auto;
      padding: 50px;
    }
    .center {
      margin-left: auto;
      margin-right: auto;
      margin-top: 5%;
      max-width: 30%;
      height: 50px;
      font-size: 1.5em;
    }
    .headerTwo {
      color: #aaa;
    }
    @media screen and (max-width: 991px) {
      .not-found {
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 10px;
        margin-top: 70px;
      }
      .headerOne {
        margin-left: auto;
        margin-right: auto;
        padding: 20px;
        font-size: 4em;
      }
      .headerTwo {
        max-width: 90%;
        font-size: 1.8em;
        margin-left: auto;
        margin-right: auto;
      }
      .center {
        font-size: 1.5em;
        margin-left: auto;
        margin-right: auto;
        height: 50px;
        max-width: 70%;
        margin-top: 20%;
      }
      .error {
        font-size: 1.2em;
      }
    }
    @media screen and (max-width: 768px) {
      .not-found {
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 10px;
        margin-top: 70px;
      }
      .headerOne {
        margin-left: auto;
        margin-right: auto;
        padding: 20px;
        font-size: 4em;
      }
      .headerTwo {
        max-width: 90%;
        font-size: 1.8em;
        margin-left: auto;
        margin-right: auto;
      }
      .center {
        font-size: 1.2em;
        margin-left: auto;
        margin-right: auto;
        height: 50px;
        max-width: 70%;
        margin-top: 20%;
      }
      .error {
        font-size: 1.2em;
      }
    }

</style>



// WEBPACK FOOTER //
// NoProductsFound.vue?0fadaf86